import styled, { ThemeProps } from 'styled-components';
import { Theme, ThemeColors } from '../theme';
import { font, media } from '../theme/base/mixins';
import {
  StyledDivComponent,
  StyledLIComponent,
  StyledUListComponent
} from '../types';
import { Column } from './Grid';
import { Icon } from './Icon';
import { Anker, TextLink } from './Link';

interface BreadcrumbProps {
  bg?: keyof ThemeColors;
}

type BreadcrumbPropsThemed = BreadcrumbProps & ThemeProps<Theme>;

export const Breadcrumb: StyledDivComponent<BreadcrumbProps> = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 30px;
  background: ${({ bg, theme }: BreadcrumbPropsThemed) =>
    bg ? theme.colors[bg] : theme.colors.grayBg};

  ${Column} {
    &:not(:first-child) {
      text-align: right;
    }
  }

  ${media.large`
      margin-bottom: 80px;
      margin-top: 2px;
  `};
`;

export const BreadcrumbList: StyledUListComponent = styled.ul``;

export const BreadcrumbItem: StyledLIComponent = styled.li`
  display: inline;

  ${TextLink},
  ${Anker} {
    ${font(1.6, 2, '300')}

    color: ${(props: ThemeProps<Theme>) => props.theme.colors.grayDark};
    vertical-align: middle;

    &[href]:hover {
      color: ${(props: ThemeProps<Theme>) => props.theme.colors.primaryHover};
    }
  }

  ${Icon} {
    width: 10px;
    height: 10px;
    margin-left: 14px;

    svg {
      width: 10px;
      height: 10px;
      fill: ${(props: ThemeProps<Theme>) => props.theme.colors.grayMedium};
    }
  }
`;
